import { useAuthRouter } from '../utils/AuthRouter';
import { useOAuthHandler } from '../utils/OAuthHandler';
import { ReactNode } from 'react';

const ProtectedRoute = ({ children }: { children: ReactNode }) => {
  const { isLoading } = useAuthRouter();
  useOAuthHandler(); // Handle OAuth params if present

  if (isLoading) {
    return (
      <div className="z-40 flex h-[100vh] w-[100vw] flex-col items-center justify-center align-middle">
        <img
          alt="loading-icon"
          src="/Icon-v2.gif"
          className="flex h-44 w-44 justify-center"
        />
        <h2 className="text-[14px] text-secondary">Authenticating...</h2>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
